<template>
    <div class="testimonial-section">
        <div class="testimonial-wrapper">
            <div class="testimonial-quote">
                <span class="quote-text fuente-nova">
                    Con Efisense Rewards, creamos una experiencia de fidelización personalizada que realmente conecta con nuestros clientes.
                </span>
                <span class="quote-text fuente-nova">
                    Las encuestas automáticas nos dan feedback valioso y las gift cards digitales se han convertido en un importante canal de ventas adicional.
                </span>
            </div>

            <div class="testimonial-author">
                <div class="company-logo">
                    <img :src="companyLogo" alt="Logo">
                </div>
                <span class="author-name fuente-nova2">Martin Cardos Herrera</span>
                <span class="author-title fuente-nova">Supervisor de Marca</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TestimonioRewardNew',
    data() {
        return {
            companyLogo: require('@/assets/images/parroquia.png'),
        }
    },
}
</script>

<style lang="css" scoped>
.testimonial-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 40px;
    box-sizing: border-box;
    scroll-snap-align: start;
}

.testimonial-wrapper {
    max-width: 700px;
    z-index: 1;
}

.testimonial-quote {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.quote-text {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.4;
    display: block;
}

.testimonial-author {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.author-name {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.1;
    padding-left: 10px;
}

.author-title {
    color: var(--color-1);
    font-size: 22px;
    line-height: 1.1;
    margin-top: 5px;
    padding-left: 10px;
}

.company-logo {
    width: 150px;
    flex-shrink: 0;
}

.company-logo img {
    width: 100%;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .quote-text {
        font-size: 23px;
    }
    .author-name {
        font-size: 23px;
    }
    .author-title {
        font-size: 20px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .testimonial-section {
        height: 100vh;
        min-height: 100vh;
        padding: 100px 20px 40px 20px;
        align-items: flex-start;
    }

    .testimonial-wrapper {
        width: 100%;
    }

    .testimonial-quote {
        gap: 15px;
    }

    .quote-text {
        font-size: 17px;
    }

    .testimonial-author {
        margin-top: 30px;
    }

    .author-name {
        font-size: 15px;
    }

    .author-title {
        font-size: 12px;
    }

    .company-logo {
        width: 35vw;
        max-width: 150px;
    }
}
</style>
